<template>
  <div class="w-100vw h-100vh_76px">
    <div class="w-100 h-100 d-fx jc-c ai-c">
      <img class="w-100 h-100 xw-458px xh-489px"
      :src="getImage(`pageNotFound`)" :alt="getImage(`pageNotFound`)">
    </div>
  </div>
</template>

<script>
export default {
  name: 'notFoundV',
  extends: {},
  props: {},
  data(){
    return{
      publicPath: process.env.BASE_URL,
    };
  },
  components: {},
  computed: {},
  watch: {},
  methods: {
    getImage(name) {
      return `${this.publicPath}images/pageNotFound/${name}.png`
    }

    // for image from assets
    // getImage(name){
    //   return require(`@/assets/images/pageNotFound/${name}.png`)
    // }
  },
  beforeCreate(){},
  mounted(){}
}
</script>
